import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubmitRequest = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "submitRequest",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16832",
		"data-name": "Group 16832",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_12488",
			"data-name": "Path 12488",
			d: "M12.472,11.908V7.477A1.477,1.477,0,0,0,10.995,6h0A1.476,1.476,0,0,0,9.519,7.477V16L6.873,14.642a1.558,1.558,0,0,0-1.813.284h0a1.558,1.558,0,0,0,.065,2.264l4.825,4.3A2,2,0,0,0,11.281,22h4.633a2,2,0,0,0,1.952-1.566l1.189-5.351a2,2,0,0,0-1.646-2.41Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_12489",
			"data-name": "Path 12489",
			d: "M12.643,9H17a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V7A2,2,0,0,0,5,9H9.357",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12490",
		"data-name": "Path 12490",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgSubmitRequest;
